// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"2d215328","568":"c6f1bae4"}[chunkId] + ".chunk.js";
};